import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"
import _imports_0 from '@/assets/images/hi-five.svg'


const _hoisted_1 = { class: "container" }
const _hoisted_2 = {
  class: "main",
  role: "main"
}
const _hoisted_3 = { class: "row justify-content-between" }
const _hoisted_4 = { class: "col-md-6" }
const _hoisted_5 = { class: "info-card" }
const _hoisted_6 = { class: "d-flex" }
const _hoisted_7 = { class: "d-flex" }
const _hoisted_8 = { class: "form-card" }
const _hoisted_9 = { class: "row" }
const _hoisted_10 = { class: "alert__icon" }
const _hoisted_11 = { class: "alert__content" }
const _hoisted_12 = {
  class: "btn-close align-items-center",
  type: "button",
  "data-bs-dismiss": "alert",
  "aria-label": "Fechar"
}
const _hoisted_13 = {
  key: 0,
  id: "codigo",
  style: {"word-break":"break-all"}
}
const _hoisted_14 = ["title"]
const _hoisted_15 = { class: "justify-content-start" }
const _hoisted_16 = ["href"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Breadcrumb = _resolveComponent("Breadcrumb")!
  const _component_Icon = _resolveComponent("Icon")!
  const _component_Contact = _resolveComponent("Contact")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_Breadcrumb),
    _cache[9] || (_cache[9] = _createElementVNode("h1", { class: "h-medium-lg fw-500" }, "Seus documentos foram enviados com sucesso!", -1)),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _cache[4] || (_cache[4] = _createElementVNode("h2", { class: "color--primary" }, "O que vai acontecer agora?", -1)),
            _createElementVNode("p", _hoisted_6, [
              _createVNode(_component_Icon, {
                class: "icon-check",
                name: "circle-check"
              }),
              _cache[2] || (_cache[2] = _createElementVNode("span", null, [
                _createTextVNode("Agora um de nossos Agentes fará a "),
                _createElementVNode("strong", null, "análise dos documentos.")
              ], -1))
            ]),
            _createElementVNode("p", _hoisted_7, [
              _createVNode(_component_Icon, {
                class: "icon-check",
                name: "circle-check"
              }),
              _cache[3] || (_cache[3] = _createElementVNode("span", null, [
                _createTextVNode("Assim que estiver tudo certo, você "),
                _createElementVNode("strong", null, "receberá as instruções para os próximos passos no seu e-mail.")
              ], -1))
            ])
          ]),
          _createElementVNode("div", _hoisted_8, [
            _cache[7] || (_cache[7] = _createElementVNode("h4", { class: "fw-400" }, "Enquanto isso você pode consultar o andamento da sua solicitação.", -1)),
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("div", {
                class: _normalizeClass(["alert alert-dismissible col-lg-12", [_ctx.alert.isShow ? "d-flex " : "d-none"]]),
                role: "alert"
              }, [
                _createElementVNode("div", _hoisted_10, [
                  _createVNode(_component_Icon, { name: _ctx.getIconAlert }, null, 8, ["name"])
                ]),
                _createElementVNode("div", _hoisted_11, _toDisplayString(_ctx.alert.message), 1),
                _createElementVNode("button", _hoisted_12, [
                  _createVNode(_component_Icon, {
                    class: "icon",
                    name: "xmark"
                  })
                ])
              ], 2)
            ]),
            (_ctx.form.codigoSolicitacao !== "")
              ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                  _createElementVNode("div", {
                    id: "tooltip-cod",
                    title: _ctx.tooltipMessage,
                    onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.copyTextToClipboard && _ctx.copyTextToClipboard(...args))),
                    onMouseover: _cache[1] || (_cache[1] = ($event: any) => (_ctx.createTooltip("#tooltip-cod")))
                  }, null, 40, _hoisted_14),
                  _cache[5] || (_cache[5] = _createElementVNode("span", { class: "text-by-copie" }, "Código da solicitação: ", -1)),
                  (_openBlock(), _createElementBlock("span", {
                    class: "fw-600 button-copy",
                    key: _ctx.count
                  }, _toDisplayString(_ctx.form.codigoSolicitacao), 1)),
                  _createVNode(_component_Icon, {
                    class: "col-2 button-copy ms-2",
                    name: "copy"
                  })
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_15, [
              _createElementVNode("a", {
                class: "btn btn-primary col-md-12 col-lg-6",
                id: "btnCopy",
                type: "button",
                target: "_blank",
                href: `https://${_ctx.arData.subdomain}.acsoluti.com.br/site/verificar-situacao-de-emissao`
              }, [
                _cache[6] || (_cache[6] = _createElementVNode("span", null, "Consultar andamento", -1)),
                _createVNode(_component_Icon, {
                  class: "ms-2",
                  name: "magnifying-glass"
                })
              ], 8, _hoisted_16)
            ])
          ])
        ]),
        _cache[8] || (_cache[8] = _createElementVNode("div", { class: "col-md-6 card-image" }, [
          _createElementVNode("img", { src: _imports_0 })
        ], -1))
      ])
    ]),
    _createVNode(_component_Contact, { style: {"margin-bottom":"6rem"} })
  ]))
}